import { render } from "./cookieConsent.vue?vue&type=template&id=663c76bc&scoped=true"
import script from "./cookieConsent.vue?vue&type=script&lang=js"
export * from "./cookieConsent.vue?vue&type=script&lang=js"

import "./cookieConsent.vue?vue&type=style&index=0&id=663c76bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663c76bc"]])

export default __exports__